import { Serializable } from '@core/models';
import i18n from '@core/plugins/i18n';
import { OutOfMenuDayService } from './outOfMenuDayService';

export class OutOfMenuDay extends Serializable {
  static CONTAINER_STYLE = 'display: flex;flex-direction: column;min-width: 30%;margin-bottom:15px;'

  static TABLE_STYLE = 'min-width: 30%;table-layout: fixed;border-collapse:collapse;'

  static ALL_CELLS_STYLE = 'padding: 4px; border: 1px solid #bbb;'

  static REGULAR_CELLS_STYLE = `${OutOfMenuDay.ALL_CELLS_STYLE}width: 50%;`

  static HEADER_CELLS_STYLE = `${OutOfMenuDay.ALL_CELLS_STYLE}text-align:center;`

  constructor(title, services) {
    super();
    const parsedDate = new Date(title);
    this.title = !Number.isNaN(parsedDate.getTime()) ? i18n.d(new Date(title), 'long') : 'Malformed date';
    this.services = services;
  }

  serialize() {
    return {};
  }

  getHtmlHeader() {
    return `<td style="${OutOfMenuDay.HEADER_CELLS_STYLE}" colspan="2"><b>${this.title}</b></td>`;
  }

  getHtmlServices() {
    // [[title, forecast_group, product, product...], [title, forecast_group, product, product]]
    const services = this.services.map((service) => service.formatForHtml());
    const transposedServices = [];
    const numberOfRows = Math.max(...services.map((service) => service.length));
    for (let column = 0; column < services.length; column++) {
      for (let row = 0; row < numberOfRows; row++) {
        if (!transposedServices[row]) {
          transposedServices[row] = [];
        }
        transposedServices[row][column] = services[column][row] || '';
      }
    }
    // [[title, title]
    // [product, product]
    // [product, product]]
    let res = '';
    const header = transposedServices.shift();
    res += `<tr>${header.map((column) => `<td style="${OutOfMenuDay.HEADER_CELLS_STYLE}"><b>${column}</b></td>`).join('')}</tr>`;
    res += transposedServices.map((row) => `<tr>${row.map((column) => `<td style="${OutOfMenuDay.REGULAR_CELLS_STYLE}">${column}</td>`).join('')}</tr>`).join('');
    return res;
  }

  serializeHtml() {
    return `<div style="${OutOfMenuDay.CONTAINER_STYLE}"><table style="${OutOfMenuDay.TABLE_STYLE}"><tbody><tr>${this.getHtmlHeader()}</tr>${this.getHtmlServices()}</tbody></table></div>`;
  }

  static toInstance(props = {}) {
    const services = OutOfMenuDayService.toInstanceList(props.services);
    return new OutOfMenuDay(props.title, services);
  }
}
